import React, { useContext, useEffect, useRef, useState } from "react";
import closebutton from "../../assests/closebutton.svg";
import styles from "./CoverPhotoUpdate.module.css";
import _, { isEmpty } from "lodash";
import axios from "axios";
import Context from "../../context/Context";
import { useUserAuth } from "../../context/UserAuthContext";
import { mediaStorage } from "../../store/firebase-config";
import { ref, uploadBytesResumable } from "firebase/storage";
import UploadPopup from "../UploadPopup/UploadPopup";

export default function CoverPhotoUpdate({ data, setPopup, setUpdateSuccess }) {
  const [errorMessage, setErrorMessage] = useState({});

  const { userIdToken } = useContext(Context);
  const { currentUser, newUserId, userId, loginChecker } = useUserAuth();
  const [loading, setLoading] = useState(false);
  const [source, setSource] = useState();
  const [selectedFile, setSelectedFile] = useState();
  const inputRef = useRef();
  const [upload, setUpload] = useState(false);
  const token = userIdToken || currentUser?.accessToken;

  useEffect(() => {
    if (isEmpty(userId) && isEmpty(newUserId)) {
      loginChecker(token);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const buttonType = e.nativeEvent.submitter.getAttribute("type");
    if (buttonType === "submit") {
      let errors = {};

      if (_.isEmpty(source)) {
        errors.proofData = "Please upload a cover photo";
      }

      setErrorMessage(errors);
      if (_.isEmpty(errors)) {
        setUpload(true);
        const uploadData = await fileUpload();
        await updateEntry(uploadData);
        setUpload(false);
      }
    }
  };
  const updateEntry = async (fileData) => {
    setLoading(true);
    try {
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_UPDATE_COVER_PHOTO}/${data?.orgId}/${data?.campaignId}/${data?.contestId}/${data?._id}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: {
          defaultThumbnail: false,
          thumbnailUrl: fileData?.fileUrl,
          thumbnailObject: {
            bucket: "goviralmedias",
            contentType: fileData?.fileType,
            name: fileData?.filePath,
          },
        },
      };
      const apiResponse = await axios(config);
      if (apiResponse?.data?.status == "success") {
        setPopup(false);
        setLoading(false);
        setUpdateSuccess(true);
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };
  const fileUpload = async () => {
    try {
      let userIdFromLocalOrApi = newUserId || userId;
      let randomId = Math.floor(Date.now() * Math.random());

      let filePath = `${data?.orgId}/${data?.campaignId}/${data?.contestId}/${userIdFromLocalOrApi}/${data?.orgId}_${data?.campaignId}_${data?.contestId}_${userIdFromLocalOrApi}_${randomId}_thumbail`;
      const storageRef = ref(mediaStorage, filePath);
      const uploadTask = uploadBytesResumable(storageRef, selectedFile);
      await uploadTask;

      // const url = await getDownloadURL(uploadTask.snapshot.ref);
      const thumbanilData = {
        fileSize: selectedFile.size,
        fileType: selectedFile.type,
        fileUrl: "https://storage.googleapis.com/goviralmedias/" + filePath,
        filePath: filePath,
      };
      return thumbanilData;
    } catch (error) {
      console.error(error);
    }
  };

  const handleFileChange = async (event) => {
    const selectedFile = new FormData();
    const file = event.target.files[0];
    const url = URL.createObjectURL(file);
    selectedFile.append("selectedFile", file);
    setSource(url);
    setSelectedFile(file);
  };
  const handleChoose = async () => {
    inputRef.current.click();
  };

  return (
    <>
      {upload && <UploadPopup />}
      <div
        className={`fixed top-0 left-0 h-[100%] w-[100%] z-10 px-[20px] ${styles.popupBackground} overflow-y-auto no-scrollbar`}
      >
        <div className={`${styles.popupParent}`}>
          <div className="relative w-[100%]">
            <div className="flex justify-between items-center w-[100%] p-[20px]">
              <p className="text-regular-bold text-[#CDCDCD]">
                Update Cover Photo
              </p>
              <img
                src={closebutton}
                onClick={() => setPopup(false)}
                className=" hover:cursor-pointer"
              />
            </div>
            <form className={styles.claimForm} onSubmit={handleSubmit}>
              <div className="flex flex-col  mt-[20px]">
                <label htmlFor="participantName" className=" ">
                  Change Cover Image <span className="text-[#FA6B6B]">*</span>
                </label>
                <div className="w-[100%]">
                  <span className="text-[#B5B5B5]  text-smallest">
                    Can be any image to showcase the video.
                  </span>
                </div>
                <input
                  ref={inputRef}
                  className="hidden"
                  type="file"
                  onChange={handleFileChange}
                  accept="image/*"
                />
                <div className="flex w-full justify-center mt-[10px]">
                  {source ? (
                    <div
                      className="w-[100%] min-h-[60px]  overflow-hidden text-center cursor-pointer text-white focus:outline-0  font-Inter font-[400] text-[17px] leading-[24px]"
                      onClick={handleChoose}
                    >
                      <div>
                        <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px] rounded-[5px] bg-[#1c1c1c] px-[15px] py-[18px]">
                          <img src={source} className="w-auto h-[100%]" />
                        </div>
                        <button className="text-small text-[#8B8B8B] bg-[#252525] rounded-[6px] py-[8px] px-[17px] mt-[10px] w-fit mx-auto">
                          Replace
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="w-[100%] min-h-[60px]  overflow-hidden text-center cursor-pointer text-white focus:outline-0  font-Inter font-[400] text-[17px] leading-[24px]"
                      onClick={handleChoose}
                    >
                      <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px] rounded-[5px] bg-[#1c1c1c] px-[15px] py-[18px]">
                        <button className="text-small text-[#8B8B8B] bg-[#252525] rounded-[6px] py-[8px] px-[17px] mt-[10px] w-fit mx-auto">
                          Select
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                {errorMessage?.proofData && (
                  <p className="text-[#FA6B6B] text-smallest mt-[5px]">
                    {errorMessage?.proofData}
                  </p>
                )}
              </div>
              <div className="w-full mt-[16px] flex">
                <button
                  type="submit"
                  className="ml-auto w-fit drop-shadow px-[12px] py-[5px] bg-[#262626] text-[#f6f6f6] rounded-[10px] text-regular"
                  disabled={loading}
                >
                  {loading ? "Loading" : "Upload"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
